import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Card, Cell, Text, Spacer, Badge, Image } from '@vinted/web-ui';
import { STATIC_ASSETS_URL } from 'constants/index';
import useIsDarkMode from 'hooks/useIsDarkMode';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const VAS_IMAGES = ['vas-bump', 'vas-closet-promo', 'vas-closet-promo-stats', 'vas-featured-collection', 'vas-gallery-card'];

const VasBanner = _ref => {
  let {
    title,
    subtitle,
    icon,
    url,
    onClick,
    testId,
    badgeTitle,
    badgeSubtitle
  } = _ref;
  const isDarkMode = useIsDarkMode();

  const getIconElement = () => {
    if (!icon) {
      return null;
    }

    if (VAS_IMAGES.includes(icon)) {
      const imageName = "".concat(icon).concat(isDarkMode ? '-dark' : '');
      return /*#__PURE__*/_jsx(Image, {
        src: "".concat(STATIC_ASSETS_URL, "/assets/profile-banners/").concat(imageName, ".svg"),
        size: Image.Size.XLarge,
        testId: imageName
      });
    }

    return null;
  };

  const renderBanner = () => {
    const navigationProp = onClick ? {
      onClick
    } : {
      url
    };
    const prefix = getIconElement();

    const body = /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Text, {
        text: subtitle,
        type: Text.Type.Subtitle,
        html: true
      }), badgeTitle && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Spacer, {
          size: Spacer.Size.Medium
        }), /*#__PURE__*/_jsx(Cell, {
          styling: Cell.Styling.Tight,
          theme: "transparent",
          prefix: /*#__PURE__*/_jsx(Badge, {
            content: badgeTitle,
            theme: "primary"
          }),
          body: badgeSubtitle && /*#__PURE__*/_jsx(Text, {
            type: Text.Type.Caption,
            text: badgeSubtitle
          })
        })]
      })]
    });

    return /*#__PURE__*/_jsx(Cell, _objectSpread({
      title: title,
      body: body,
      type: Cell.Type.Navigating,
      prefix: prefix,
      testId: testId,
      theme: "transparent"
    }, navigationProp));
  };

  return /*#__PURE__*/_jsx("div", {
    className: "u-fill-width u-fill-child-component",
    children: /*#__PURE__*/_jsx(Card, {
      experimentalTheme: "primaryLightExperimental",
      children: /*#__PURE__*/_jsx("div", {
        className: "u-overflow-hidden u-fill-height u-fill-child-component",
        children: renderBanner()
      })
    })
  });
};

export default VasBanner;